import { render, staticRenderFns } from "./FinNoticeInfo.vue?vue&type=template&id=b980e728&scoped=true&"
import script from "./FinNoticeInfo.vue?vue&type=script&lang=js&"
export * from "./FinNoticeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b980e728",
  null
  
)

export default component.exports